import { Palette } from "@/constants/theme";

const AVATAR_COLORS = [
  Palette.blue,
  Palette.blueDark,
  "#5B8DEF",
  "#6C5CE7",
  "#0EA5E9",
  "#14B8A6",
  "#F97316",
  "#EC4899",
  "#22A06B",
  "#7C3AED",
];

function hash(seed: string): number {
  let h = 0;
  for (let i = 0; i < seed.length; i += 1) {
    h = (Math.imul(31, h) + seed.charCodeAt(i)) | 0;
  }
  return Math.abs(h);
}

export function avatarColor(seed: string): string {
  return AVATAR_COLORS[hash(seed) % AVATAR_COLORS.length];
}

export function avatarInitials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "🙂";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[1][0]).toUpperCase();
}
